import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || 'https://zdt.sxyqyf.com/api/v1',
  timeout: 30000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 添加token到请求头
    const token = store.getters.token
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    
    // 为系统管理员和超级管理员添加特殊标识，让后端识别管理员身份
    const adminInfo = store.getters.adminInfo
    if (adminInfo) {
      // 添加用户角色信息到请求头
      config.headers['X-User-Role'] = adminInfo.role_type
      config.headers['X-User-ID'] = adminInfo.id
      
      // 如果是系统管理员或超级管理员访问门店相关接口，添加管理员标识
      if ((adminInfo.role_type === 1 || adminInfo.role_type === 2) && 
          (config.url.includes('/store/') || config.url.includes('/product/store/'))) {
        config.headers['X-Admin-Access'] = 'true'
      }
    }
    
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    
    // 如果返回的状态码为200，说明成功，可以直接返回数据
    if (res.code === 200) {
      return res
    }
    
    // 其他状态码都作为错误处理
    Message({
      message: res.message || '请求失败',
      type: 'error',
      duration: 3000
    })
    
    return Promise.reject(new Error(res.message || '请求失败'))
  },
  error => {
    console.error('响应错误:', error)
    
    let message = '网络请求失败'
    
    if (error.response) {
      const { status, data } = error.response
      
      switch (status) {
        case 401:
          message = '登录已过期，请重新登录'
          store.dispatch('logout')
          router.push('/login')
          break
        case 403:
          message = '权限不足'
          break
        case 404:
          message = '请求的资源不存在'
          break
        case 500:
          message = '服务器内部错误'
          break
        default:
          message = (data && data.message) || `请求失败 (${status})`
      }
    } else if (error.code === 'NETWORK_ERROR') {
      message = '网络连接失败'
    } else if (error.code === 'ECONNABORTED') {
      message = '请求超时'
    }
    
    Message({
      message,
      type: 'error',
      duration: 3000
    })
    
    return Promise.reject(error)
  }
)

export default service 